import { autorun } from "mobx";
import LoginStore from "./LoginStore";
import ProfileStore from "./ProfileStore";
import SharedStore from "./SharedStore";
import Utility from "../common/utility";

class RootStore {
  constructor() {
    this.loginStore = new LoginStore(this);
    this.profileStore = new ProfileStore(this);
    this.sharedStore = new SharedStore(this);
    autorun((a) => {
      let sharedStoreData = Utility.getData("sharedStore");
      if (!sharedStoreData) {
        sharedStoreData = {};
      }
      sharedStoreData.userRole = this.sharedStore.userRole;
      sharedStoreData.membersData = this.sharedStore.membersData;
      sharedStoreData.timezoneData = this.sharedStore.timezoneData;
      sharedStoreData.isShowInviteeModal = this.sharedStore.isShowInviteeModal;
      sharedStoreData.tempPassword = this.sharedStore.tempPassword;
      sharedStoreData.username = this.sharedStore.username;
      sharedStoreData.profileData = this.sharedStore.profileData;
      sharedStoreData.invoicesData = this.sharedStore.invoicesData;
      sharedStoreData.licenseData = this.sharedStore.licenseData;
      sharedStoreData.selectedInvoice = this.sharedStore.selectedInvoice;
      sharedStoreData.paymentArr = this.sharedStore.paymentArr;
      sharedStoreData.bankArr = this.sharedStore.bankArr;
      sharedStoreData.companyLicenseType = this.sharedStore.companyLicenseType;
      sharedStoreData.customerSeriesType = this.sharedStore.customerSeriesType;
      sharedStoreData.isCustomPayment = this.sharedStore.isCustomPayment;
      sharedStoreData.versionArr = this.sharedStore.versionArr;
      sharedStoreData.versionData = this.sharedStore.versionData;
      sharedStoreData.downloadData = this.sharedStore.downloadData;
      sharedStoreData.showLoginDropdown = this.sharedStore.showLoginDropdown;
      sharedStoreData.banner_notification = this.sharedStore.banner_notification;
      sharedStoreData.selectedCurrentVersion = this.sharedStore.selectedCurrentVersion;
      sharedStoreData.versionOptions = this.sharedStore.versionOptions;
      Utility.setData("sharedStore", sharedStoreData);
    });
  }
}

const rootStore = new RootStore();

export default rootStore;



// WEBPACK FOOTER //
// ./src/stores/RootStore.js